import e from "react";
import { getIconColor as d } from "./iconfont.es5470.js";
import h from "./iconfont.es5471.js";
const r = {
  display: "block"
}, v = ({ size: a = 16, useVw: l, useRem: n, color: o, withColor: c, removeClassName: t, disableSSR: p, style: i, ...m }) => {
  const f = i ? { ...r, ...i } : r;
  return /* @__PURE__ */ e.createElement(h, { disableSSR: p }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "32px-dailishangfuwu", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: l ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (n ? "rem" : "px"), height: l ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (n ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: f, fill: "none", ...m }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: t ? "" : "32px-ä»£çåæå¡"
    },
    /* @__PURE__ */ e.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: c ? d(o, 0, "#262933") : "#262933",
        datafollowfill: c ? d(o, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M12.854 3.869a5.508 5.508 0 1 0 0 11.015 5.508 5.508 0 0 0 0-11.015ZM9.146 9.377a3.708 3.708 0 1 1 7.416 0 3.708 3.708 0 0 1-7.416 0Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M20.396 4.675a.9.9 0 1 0-.792 1.616 3.706 3.706 0 0 1 2.066 3.011 3.705 3.705 0 0 1-1.516 3.323.9.9 0 0 0 1.06 1.455 5.505 5.505 0 0 0 2.25-4.933 5.505 5.505 0 0 0-3.068-4.472Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M3.9 23.103A6.003 6.003 0 0 1 9.905 17.1h7.45a6.003 6.003 0 0 1 6.003 6.003v1.02a3.962 3.962 0 0 1-3.962 3.962H7.863A3.962 3.962 0 0 1 3.9 24.123v-1.02ZM9.905 18.9A4.203 4.203 0 0 0 5.7 23.103v1.02c0 1.194.968 2.162 2.162 2.162h11.532a2.162 2.162 0 0 0 2.162-2.162v-1.02a4.203 4.203 0 0 0-4.203-4.203h-7.45Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M24.916 17.343a.9.9 0 1 0-1.231 1.314l1.303 1.222a5.1 5.1 0 0 1 1.612 3.72V27a.9.9 0 0 0 1.8 0v-3.4a6.9 6.9 0 0 0-2.18-5.034l-1.304-1.223Z"
        }
      )
    )
  )));
}, g = v;
export {
  g as default
};
